<template
  ><!-- 红包雨 --><!-- 裂变神券 --><!-- 评价有礼 -->
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img
        class="pointer"
        @click="returnBack()"
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg"
        alt=""
      /> -->
      <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 99">
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                @click="handleTem(item, index)"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #D4E2FF;"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #EAF1FF;"
                ></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width:100%;"
                    :src="item.templateUrl || item.imageUrl"
                    alt=""
                  />
                  <img v-if="item.days" class="temImg_content_img_free" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg" alt="" srcset="" />
                  <div v-if="item.days" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.title || item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item, 2)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 99">
        <div v-if="activityData.id != 22">
          <jd-tip>
            <template v-if="activityData.id == 20">
              <div>
                注意：<br/>
                <p>
                  1、因京东平台规定:消费者可对60天内购买的商品进行评价,故软件拉取近60天内评价状态可参与活动；<a
                    style="color:#fe4d45;"
                    class="pointer"
                    href="https://rule.jd.com/rule/ruleDetail.action?ruleId=4285"
                    target="_blank"
                    >查看平台规则</a
                  >
                </p>
                <p>
                  2、单个订单中包含几款商品则可获几次抽奖机会，虚拟商品无法获得抽奖机会；
                </p>
                <p>
                  3、因京东系统需要对评价和晒单内容进行审核,如果客户没有获得参与活动机会,需要通过商家后台核实客户的评论状态;
                </p>
              </div>
            </template>
            <template v-if="activityData.id == 21">
              <div>
                商家须知：<br/>
                <p>
                  1、为避免因奖品发完活动提前结束引起客诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
                </p>
                <p>
                  2、为避免修改成团条件导致客诉，活动创建后成团条件将不可修改，请在创建时仔细核对
                </p>
                <p>3、活动期间每个用户，同一优惠最多获得一次</p>
              </div>
            </template>
          </jd-tip>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="130px"
        >
          <informationForm 
            v-model="ruleForm"
            needNonMember
            :defaultActivityStartTime.sync="ruleForm.activityStartTime"
            :defaultActivityEndTime.sync="ruleForm.activityEndTime"
            :localStepNum="localStepNum"
            :defaultActMember.sync="actMember"
            :plusObject.sync="ruleDto.plusObject"
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :disabled="isStart"
            :peopleSelected.sync="peopleSelected"
            :isShowCondFollow="activityData.id == 21 ? false : true"
            @selectPeopleSure="selectPeopleSure"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <!-- <jd-title label='基本信息' type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请填入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime"></i>
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>

          <el-form-item
            label="活动对象:"
            prop="partner"
            v-if="
                activityData.id == 20 ||
                activityData.id == 21 ||
                activityData.id == 22
            "
          >
            <el-radio v-model="actMember" label="1" :disabled="isStart">不限</el-radio>
            <el-radio v-model="actMember" label="2" :disabled="isStart">会员身份</el-radio>
            <el-radio v-model="actMember" label="3" :disabled="isStart || softType == 1">指定人群
              <el-button style="margin-left:10px;" v-if="actMember == '3'" :disabled="isStart" @click="openCrowd">已选人群({{peopleSelected.length}})</el-button>
            </el-radio>
            <div v-if="actMember == '2'" style="display:flex">
                <span>会员等级：</span>
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStart"
              v-if="actMember == '2'"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >
              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <i v-if="!isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color:#F56C6C">注意：该条件对【非会员】身份不生效</span>

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:"
            v-if="
                activityData.id == 20 ||
                activityData.id == 21 ||
                activityData.id == 22
            " required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="isStart">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="isStart">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="isStart">非plus会员</el-radio>
            <div style="color:#F56C6C">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item>

          <el-form-item label="活动条件:" v-if="activityData.id != 21">
            <el-checkbox v-model="ruleForm.condFollow" :disabled="isStart"
              >关注店铺后方可参与活动</el-checkbox
            ></el-form-item
          > -->
          <!-- 红包雨 -->
          <template v-if="activityData.id == 22">
            <jd-title label='游戏设置' type="bold"></jd-title>
            <el-form-item label="游戏时间:" required>
              <el-input
                v-model="ruleForm.gameTime"
                maxlength="3"
                @input.native="ruleForm.gameTime = checkputn($event)"
                style="width:70px"
                placeholder="请输入"
                :disabled="isStart"
              ></el-input>
              秒倒计时
              <el-tooltip
                class="item"
                effect="light"
                style="color:#ccc !important"
                content="红包掉落总个数=游戏时间*3"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <jd-title label='奖项设置' type="bold"></jd-title>
            <el-form-item label="奖项设置:" required>
              <jd-table
                :tableData="awardSettingsLsit"
                style="width: 100%;margin: 10px 0 12px 0;"
              >
                <el-table-column label="奖项级别" width="100">
                  <template slot-scope="scope">
                    <span>{{ (scope.$index + 1) | toChinesNum }}等奖</span>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <jd-button
                      type="blueText"
                      @click="selectPacket(scope.$index, scope.row)"
                      >选奖品</jd-button
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值"
                  width="80"
                  prop="price"
                ></el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品总数" width="200">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.totalAmount"
                      @input="(e) => (scope.row.totalAmount = checkputn(e,scope.row,'jindou'))"
                      @input.native="scope.row.totalAmount = checkputn($event),prizeNum(scope.row)"
                      maxlength="10"
                      class="inputcount"
                      show-word-limit
                      style="width: 150px"
                      placeholder="请输入"
                      @blur="beAdd(scope.row)"
                      :disabled="isStart"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="260">
                  <template slot="header">
                    <span>获奖条件</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="每个红包分值为10分，请合理分配；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.awardMinScore"
                      @change="scoreChange(scope.row, scope.$index)"
                      placeholder="请输入"
                      style="width: 80px;margin-right:5px;"
                      @input.native="scope.row.awardMinScore = checkputn($event)"
                      :disabled="isStart"
                    ></el-input
                    >分 ~
                    <el-input
                      v-model.number="scope.row.awardMaxScore"
                      @change="scoreChange(scope.row, scope.$index)"
                      placeholder="请输入"
                      style="width: 80px;margin-right:5px;"
                      @input.native="scope.row.awardMaxScore = checkputn($event)"
                      :disabled="isStart"
                    ></el-input
                    >分
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <jd-button
                      v-if="!isStart"
                      type="blueText"
                      @click="deletePacket(scope.row, '1')"
                      >清空</jd-button
                    >
                    <jd-button
                      v-if="!isStart"
                      v-show="scope.$index != 0"
                      type="blueText"
                      style="margin-left: 8px"
                      @click="deletePacket(scope.$index)"
                      >删除</jd-button
                    >
                    <jd-button type="blueText" style="margin-left: 5px" v-if="isStart && scope.row.title"
                    @click="itemAddNum('awardSettingsLsit', scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button v-if="!isStart" @click="addPacket">
                增加奖项
              </jd-button>
            </el-form-item>
            <el-form-item label="中奖限制:">
              活动期间每人每天中奖不超过&nbsp;<el-input
                @input.native="ruleForm.everyoneWinningNum = checkputn($event)"
                style="width:60px"
                @change="orderChange"
                v-model="ruleForm.everyoneWinningNum"
                placeholder="请输入"
                :disabled="isStart"
              ></el-input
              >&nbsp; 次，累计中奖不超过&nbsp;
              <el-input
                @input.native="ruleForm.winningNum = checkputn($event)"
                @change="orderChange"
                style="width:60px"
                v-model="ruleForm.winningNum"
                placeholder="请输入"
                :disabled="isStart"
              ></el-input
              >&nbsp; 次，
            </el-form-item>
          </template>
          <!-- 裂变神券 -->
          <template v-if="activityData.id == 21">
            <jd-title label='奖项设置' type="bold"></jd-title>
            <el-form-item label="奖项设置:" required>
              <div>
                <jd-tip>
                  <div>
                    风险提示：创建活动请注意以下几点<br/>
                      1、设置活动的各个奖项，请尽量确保一个活动中的各个奖项的份数一致，避免某个奖项提前领取完，导致用户看到奖项但无法领取而客诉；<br/>
                      2、关注奖项的库存，在奖项库存即将消耗完毕的时候，及时将banner图的利益点下掉，或者新建活动补充库存；<br/>
                      3、首页活动文案的利益点注意话术的表达，建议根据库存数量描述文案，比如“前XX名开卡会送XX奖项，先到先得”；<br/>
                      4、如果券是指定会员等级的用户才可领取，建议您在创建优惠券时选择品牌会员券，勾选相应的会员等级，并与活动设置会员等级保持一致，降低客诉与盗刷风险；<br/>
                      5、请提前预估活动流量，如流量过大，请至少提前1天联系客服进行报备，以免大流量导致活动异常。
                  </div>
                </jd-tip>
              </div>

              <jd-table
                :tableData="FissionVoucherList"
                style="width: 100%;margin-top: 15px;"
              >
                <el-table-column label="优惠券名称">
                  <template slot-scope="scope">
                    <jd-button type="blueText" @click="selectCoupon(scope.row,scope.$index)">{{
                      scope.row.title ? scope.row.title : "选择优惠券"
                    }}</jd-button>
                  </template>
                </el-table-column>

                <el-table-column label="面额">
                  <template slot-scope="scope">
                    {{ scope.row.price ? scope.row.price + "元" : "" }}
                  </template>
                </el-table-column>
                <el-table-column label="使用条件">
                  <template slot-scope="scope">
                    {{
                      scope.row.quota
                        ? "满" + scope.row.quota + "可用"
                        : scope.row.quota == 0 && scope.row.price
                        ? "满0可用"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column min-width="180" max-width="250">
                  <template slot="header">
                    <span>组队人数</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="成团人数大于1，活动生效后不可更改；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.groupNums"
                      placeholder="请输入组队人数"
                      style="width: 120px"
                      @change="
                        multiple(
                          scope.row.groupNums,
                          scope.row.totalAmount,
                          scope.$index
                        )
                      "
                      @input.native="scope.row.groupNums = checkputn($event, '5')"
                      :disabled="isStart"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column min-width="180" max-width="250">
                  <template slot="header">
                    <span>发放数量</span>
                    <el-popover
                      placement="top-start"
                      offset="100"
                      trigger="hover"
                      content="发放数量必须为组队人数的N倍，以确保奖品发放顺利；"
                    >
                      <span slot="reference">
                        <p class="question_icon">!</p>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.totalAmount"
                      @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1)"
                      placeholder="请输入发放数量"
                      style="width: 120px"
                      :disabled="isStart"
                      @change="multiple(scope.row.groupNums,scope.row.totalAmount,scope.$index,scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <jd-button
                      v-if="!isStart"
                      type="blueText"
                      style="margin-right: 10px;"
                      @click="deleteaCoupon(scope.row, '1')"
                      >清空</jd-button
                    >
                    <jd-button
                      type="blueText"
                      v-if="!isStart"
                      v-show="scope.$index != 0"
                      @click="deleteaCoupon(scope.$index)"
                      >删除</jd-button
                    >
                    <jd-button type="blueText" style="margin-left: 5px" v-if="isStart && scope.row.title"
                    @click="itemAddNum('FissionVoucherList', scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </jd-table>
              <jd-button v-if="!isStart" @click="addCoupon" style="margin-top: 16px">
                添加优惠券
              </jd-button>
            </el-form-item>
          </template>
          <!-- 评价有礼 -->
          <template v-if="activityData.id == 20">
            <jd-title label='评价规则' type="bold"></jd-title>
            <el-form-item label="活动类型:" required>
              <el-radio
                v-model="ruleDto.activityType"
                :label="0"
                :disabled="isStart"
                @change="changeActivityType"
                >评价抽奖</el-radio
              >
              <el-radio
                v-model="ruleDto.activityType"
                :label="1"
                :disabled="isStart"
                @change="changeActivityType"
                >评价有礼</el-radio
              >
            </el-form-item>
            <el-form-item label="条件设置:" required>
              <div class="rule_box">
                <div class="rule_box_middle">
                  <el-form-item label="评价时间:" required>
                    <el-select
                      v-model="appraiseValue"
                      placeholder="请选择"
                      :disabled="isStart"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <div
                      style="margin-left:10px"
                      class="my_select_time"
                      v-if="appraiseValue === '0'"
                    >
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.startCommentTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                        :disabled="isStart"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.endCommentTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                        :disabled="isStart"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>

                  <el-form-item label="参与商品:" required class="zindexBox">
                    <el-radio
                      v-model="ruleForm.filterType"
                      label="0"
                      :disabled="isStart"
                      >全部商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      label="1"
                      :disabled="isStart"
                      >指定商品</el-radio
                    >
                    <jd-button
                      :class="[{'global-view-btn':backgroundOpacity}]"
                      :disabled="ruleForm.filterType == 0 || (backgroundOpacity && !isSave) || isStart"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </jd-button>
                    <draggable
                      v-if="itemListForFilter.length > 0"
                      v-model="mainImagelistFilter"
                      chosen-class="chosen"
                      :scroll="true"
                      animation="150"
                      force-fallback="true"
                      @start="isDraggingFilter = true"
                      @end="onEndFilter"
                      style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
                      filter=".unmover"
                    >
                      <transition-group type="transition">
                        <div
                          v-for="(item, index) in mainImagelistFilter"
                          :key="item.skuId"
                          style="display: inline-block; position: relative"
                          class="show_upImg2 unmover"
                          :class="isStart?'unmover':''"
                        >
                          <img
                            :src="item.logo"
                            width="120px"
                            height="120px"
                            style="display: inline-block"
                          />&nbsp;
                          <!-- <div class="delectPosible" v-if="!isSave&&!isStart">
                            <span class="delectSort">拖动排序</span>
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                              class="delectIcom"
                            />
                          </div> -->
                          <div class="delectPosible" v-if="!isStart">
                            <span class="delectSort">拖动排序</span>
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                              @click.stop="delecFilter(index)"
                              class="delectIcom"
                            />
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </el-form-item>

                  <el-form-item label="评星设置:" required>
                    <el-checkbox-group v-model="scores">
                      <el-checkbox
                        v-for="item in labelVal"
                        :label="item.value"
                        :key="item.value"
                        :disabled="isStart"
                        >{{ item.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-form-item>

                  <el-form-item label="评价字数:">
                    评价至少
                    <el-input
                      :disabled="isStart"
                      v-model="ruleForm.wordNum"
                      @input.native="ruleForm.wordNum = checkputn($event)"
                      style="width:140px"
                      placeholder="请输入"
                    ></el-input>
                    个字（空或0表示不限制）
                  </el-form-item>
                  <el-form-item label="评价图片:">
                    包含至少
                    <el-input
                      :disabled="isStart"
                      v-model="ruleForm.imgNum"
                      @input.native="ruleForm.imgNum = checkputn($event, '1')"
                      style="width:140px"
                      placeholder="请输入"
                    ></el-input>
                    张图片（空或0表示不限制，不超过9）
                  </el-form-item>
                  <el-form-item label="评价视频:">
                    包含至少
                    <el-input
                      :disabled="ruleForm.imgNum == 9 || isStart"
                      v-model="ruleForm.videoNum"
                      @input.native="ruleForm.videoNum = checkputn($event, '2')"
                      style="width:140px"
                      placeholder="请输入"
                    ></el-input>
                    段视频（空或0表示不限制，不超过1）
                    <div style="color:red;">
                      注意：图片数量+视频数量总数必须=<9
                    </div>
                  </el-form-item>
                  <el-form-item label="过滤条件:">
                    <el-checkbox
                      v-model="ruleForm.isCommentFilter"
                      :disabled="isStart"
                      >评价内容包含</el-checkbox
                    >&nbsp;
                    <el-input
                      :disabled="isStart"
                      v-model="ruleForm.commentFilter"
                      @input.native="
                        ruleForm.commentFilter = ruleForm.commentFilter.replace(
                          /，/g,
                          ','
                        )
                      "
                      style="width:200px"
                      placeholder="多个关键词之间用英文“,”隔开"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <jd-title label='奖品设置' type="bold"></jd-title>
            <div v-if="ruleDto.activityType == 0">
              <el-form-item label="中奖限制:">
                活动期间每人每天中奖不超过&nbsp;<el-input
                  @input.native="ruleForm.oneDayMaxRewardNumber = checkputn($event, '0')"
                  @change="orderChange"
                  style="width:60px"
                  v-model="ruleForm.oneDayMaxRewardNumber"
                  placeholder="请输入"
                  :disabled="isStart"
                ></el-input
                >&nbsp; 次，累计中奖不超过
                <el-input
                  @input.native="ruleForm.totalMaxRewardNumber = checkputn($event, '0')"
                  @change="orderChange"
                  style="width:60px"
                  v-model="ruleForm.totalMaxRewardNumber"
                  placeholder="请输入"
                  :disabled="isStart"
                ></el-input>
                次
                <div style="color: red;">
                  注：此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
                </div>
              </el-form-item>
              <el-form-item required style="margin-top:-27px;">
                <div style="margin-top: 30px;">
                  订单完成后发放奖励
                </div>
                <span slot="label" class="set">奖品设置:</span>
                <div class="termAdd">
                  <el-popover placement="right" width="270" trigger="hover">
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png"
                      alt=""
                    />
                    <span slot="reference">位置示意图</span>
                  </el-popover>
                  <p>
                    累计中奖率: <span class="add">{{ winningRate }} %</span>
                  </p>
                </div>
                <jd-table
                  :tableData="prizeSettingList"
                  style="width: 100%;"
                >
                  <el-table-column label="位置">
                    <template slot-scope="scope">
                      <span v-if="scope.row.index == 0">一</span>
                      <span v-if="scope.row.index == 1">二</span>
                      <span v-if="scope.row.index == 2">三</span>
                      <span v-if="scope.row.index == 3">四</span>
                      <span v-if="scope.row.index == 4">五</span>
                      <span v-if="scope.row.index == 5">六</span>
                      <span v-if="scope.row.index == 6">七</span>
                      <span v-if="scope.row.index == 7">八</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="选择奖品">
                    <template slot-scope="scope">
                      <jd-button type="blueText" v-if="isStart">选奖品</jd-button>
                      <jd-button v-else type="blueText" @click="centerVis(scope.row)"
                        >选奖品</jd-button
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品类型">
                    <template slot-scope="scope">
                      {{ getPrizeTypeName(scope.row.prizeType) }}
                      <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                      <span v-if="scope.row.prizeType == 2">京豆</span>
                      <span v-if="scope.row.prizeType == 3">实物</span>
                      <span v-if="scope.row.prizeType == 4">店铺积分</span>
                      <span v-if="scope.row.prizeType == 5">京东E卡</span>
                      <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                      <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                      <span v-if="scope.row.prizeType == 8">现金红包</span>
                      <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                      <span v-if="scope.row.prizeType == 10">礼品卡</span>
                      <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span>
                      <span v-if="scope.row.prizeType == 13">令牌</span> -->
                    </template>
                  </el-table-column>

                  <el-table-column label="值" width="80" prop="price">
                  </el-table-column>

                  <el-table-column label="奖品名称（12字内）" width="299">
                    <template slot-scope="scope">
                      <el-input
                        :disabled="scope.row.prizeType != 3||scope.row.isGoodManage"
                        v-model="scope.row.title"
                        maxlength="12"
                        show-word-limit
                        style="width: 240px"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品总数" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.totalAmount"
                        @input="(e) => (scope.row.totalAmount = checkputn(e,scope.row,'jindou'))"
                        placeholder="请输入..."
                        style="width: 70px"
                        @input.native="scope.row.totalAmount = checkputn($event),prizeNum(scope.row)"
                        @blur="beAdd(scope.row)"
                        :disabled="activityData.isStart && !scope.row.minNum || isStart"
                      ></el-input>
                      份
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120" v-if="activityData.id == 20">  
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="中奖率" width="130" >
                    <template slot-scope="scope">
                      <el-input
                        :disabled="isStart"
                        v-model="scope.row.percentage"
                        placeholder="请输入..."
                        style="width: 90px"
                        @keyup.native="
                          scope.row.percentage = oninput2(scope.row.percentage)
                        "
                      ></el-input>
                      %
                    </template>
                  </el-table-column>
                  <el-table-column label="最多中奖次数">
                    <template #header>
                      <el-tooltip
                        effect="light"
                        content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                        placement="right"
                      >
                        <div>
                          最多中奖次数<i style="color: #ccc;" class="el-icon-question"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-input
                        :disabled="isStart"
                        v-model="scope.row.singleMaxWin"
                        placeholder="请输入..."
                        style="width: 70px"
                        @input="scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="图片" width="170">
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 56px; height: 56px"
                      />
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                      <jd-button v-if="turntableType == 1 && prizeSettingList.length > 4 && !isStart" @click="delPrizeItem(scope.$index)" type="blueText">删除</jd-button>

                      <jd-button v-if="isStart" type="blueText">清除</jd-button>
                      <jd-button v-else type="blueText" @click="cleanData(scope.row)"
                        >清除</jd-button
                      >
                      <jd-button type="blueText" style="margin-left: 5px" v-if="isStart && scope.row.title"
                      @click="itemAddNum('prizeSettingList', scope.$index)">增加奖品数量</jd-button>
                    </template>
                  </el-table-column>
                </jd-table>
                <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                <div v-if="turntableType == 1" style="display: flex;align-items: center;justify-content: center;">
                  <jd-button :disabled="isStart || prizeSettingList.length >=8 " @click="addPrizeItem()" type="blueText">添加奖项({{ prizeSettingList.length }}/8)</jd-button>
                </div>
                <div style="margin-top: 8px">
                  <jd-tip>
                    说明<br/>
                    <p>
                    1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                  </p>
                  <p>
                    2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                  </p>
                  </jd-tip>
                </div>
              </el-form-item>
            </div>
            <div v-else-if="ruleDto.activityType == 1">
              <el-form-item label="奖品领取限制:" required>
                <el-radio
                  v-model="ruleDto.receiveType"
                  :label="0"
                  :disabled="isStart"
                  >仅可领取一次</el-radio
                >
                <el-radio
                  v-model="ruleDto.receiveType"
                  :label="1"
                  :disabled="isStart"
                  >活动期间每人可领取</el-radio
                >
                <el-input
                    @input.native="ruleDto.receiveNum = checkputn($event, '0')"
                    @change="orderChange"
                    style="width:80px;margin-right: 8px;"
                    v-model="ruleDto.receiveNum"
                    placeholder="请输入"
                    :disabled="ruleDto.receiveType==0||isStart"
                  ></el-input
                  >次，不填则不限制，每个阶梯仅能领取一次
              </el-form-item>
              <el-form-item label="奖品设置:" required>
                <jd-button type="blue" :disabled="activityData.isStart" @click="addEvaluatePrize">+添加奖品（{{evaluatePrizeList.length}}/4）</jd-button>
                <newPrizeTable
                  :prizeList.sync="evaluatePrizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="tableInfo"
                  :valueRow="valueRow"
                  :isIndex="isIndex"
                  :actType="20"
                  :actEndTime="ruleForm.endTime"
                  :isShowUpLoadBtn="true"
                  class="mt16"
                >
                <template #dailyLimitName="{scopeRow}">
                  <dailyLimitConfig
                    :row="scopeRow"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </newPrizeTable>
              </el-form-item>
            </div>
          </template>
          <template v-if="activityData.id == 21">
            <!--tapd 裂变神券活动添加 进店设置 -->
            <jd-title label='进店设置' type="bold"></jd-title>
            <el-form-item label="进店逛逛:">
              <el-radio-group v-model="ruleForm.goShopSetting" :disabled="isStart" @change="onShopSetChange">
               <el-radio :label="0">进入店铺首页</el-radio>
               <el-radio :label="1">跳转指定小程序</el-radio>
               <el-radio :label="2">进入指定链接</el-radio>
             </el-radio-group>
             <div style="color:#F56C6C">部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券</div>
            </el-form-item>
            <div v-if="ruleForm.goShopSetting==1">
              <el-form-item label="小程序appId:" required>
                <el-input
                  type="textarea"
                  placeholder="请输入小程序appId"
                  style="width: 425px;margin-left:8px;"
                  show-word-limit
                  v-model="ruleForm.goShopAppId"
                  :maxlength="1000"
                  :disabled="isStart"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面路径path:">
                <el-input
                 type="textarea"
                 placeholder="请输入小程序页面路径path"
                 style="width: 425px;margin-left:8px;"
                 show-word-limit
                 v-model="ruleForm.goShopUrl"
                 :maxlength="1000"
                 :disabled="isStart"
                ></el-input>
                <div style="color:#F56C6C">注意：path若不写，则默认进入小程序主页。</div>
              </el-form-item>
            </div>
            <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting==2">
              <el-input
                type="textarea"
                placeholder="请输入指定链接"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="isStart"
              ></el-input>
              <div style="color:#F56C6C">注意：仅可填写京东域内的 H5页面地址，不可设置外链。参考链接：https://m.jd.com/。</div>
            </el-form-item>
          </template>
          <activityPageSettings 
            :isShowShopName="activityData.id != 21"
            :isShowMoreSet="activityData.id == 20||activityData.id == 21"
            v-model="customerPaperwork"
            previewKey="imageUrl"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="activityData.id == 20 ? evaluateSize : activityData.id == 21 ? 1399 : 1466"
            :giftList="newGiftList"
            :templateId="templateId"
            :themeTitle="themeTitle"
            :isNeedCustomerPaperworkData="isShowActInfo"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :isNeedSetBG="activityData.id == 22 ? false : true"
            :isCustomPreview="isShowActInfo"
            :defaultRgb="currrentRgb"
            @selectTemplate="nextStepKai(newGiftList[$event])"
            :designSpecificationsUrl="designSpecificationsUrl"
          >
            <template #customPreview>
            <evaluatePreviewDialog
              :ruleDTO="ruleDto"
              :customerPaperwork="customerPaperwork"
              :templateObj="templateObj"
              :evaluatePrizeList="evaluatePrizeList"
              :backgroundImage="backgroundImage"/>
            </template>
            <template #otherSet>
              <el-form-item label="按钮背景图:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 1)"
                    :on-success="(res) => handleUploadUI(res, 1)"
                  >
                    <div v-if="customerPaperwork.btnUrl">
                      <img
                        :src="customerPaperwork.btnUrl"
                        style="width: 191px; height: auto"
                      />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.btnUrl = ''"
                    style="margin: 0 12px 0 12px"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="color-style">尺寸建议：602*94px</span>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <exposureList 
            v-model="itemListFor"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
          />
          <!-- <jd-title label='曝光商品' type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[{'global-view-btn':backgroundOpacity}]"
              style="margin: 0 8px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false ||(!isSave && activityData.id == 20)"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div
                    class="delectPosible"
                    v-if="!isSave && activityData.id == 20"
                  >
                  </div>
                  <div class="delectPosible" v-else>
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <template>
            <sharFrom 
              v-model="ruleForm"
              :sharePic="sharePic"
            />
            <!-- <jd-title label='分享设置' type="bold"></jd-title>
            <el-form-item label="小程序分享标题:" required label-width="125">
              <el-input
                  type="text"
                  style="width: 425px;margin-left:8px;"
                  show-word-limit
                  v-model="ruleForm.shareTitle"
                  :maxlength="28"
                  :disabled="isStart"
                ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required label-width="125">
              <el-input
                  type="text"
                  style="width: 425px;margin-left:8px;"
                  show-word-limit
                  v-model="ruleForm.shareIntroduce"
                  :maxlength="28"
                  :disabled="isStart"
                ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required label-width="130">
              <div class="miniAppPic" style="margin-left:16px;">
                <div class="top">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUpload1"
                    :on-success="handleUpload1"
                    :disabled="isStart"
                    >
                    <jd-button type="blueText" style="margin-right: 20px">自定义上传</jd-button>
                  </el-upload>
                  <jd-button type="blueText" @click="picUrlReset1">重置</jd-button>
                </div>
                <div class="bottom">
                  <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips11">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item> -->
          </template>
          <activityRules 
            v-model="ruleForm.activityRulesText"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label='活动规则' type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
              width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
              <div style="margin-top: 16px">
                <jd-button
                  type="blue"
                  @click="generateRule"
                >
                  生成规则
                </jd-button>
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->
          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 99">
      <jd-button
        v-show="!itemId && backgroundOpacity"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="saveEdit"
          v-preventReClick
          >保存设置</jd-button
        >
        <jd-button
          v-show="!itemId"
          v-if="statusComment"
          type="blue"
          @click="saveEdit"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button
        v-show="itemId"
        @click="cancelEdit"
        style="margin-right: 8px"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue"
        >保存设置</jd-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false" style="margin-right: 8px">取消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="break"
          >确定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      v-if="showSelectProduct"
      ref="selectProduct"
      :echoDate="echoDate"
      :actId="valueRow"
      :num="1"
      :JingdouCount="JingdouCount"
      :actType="activityData.id"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 红包雨 选择奖品弹窗 -->
    <selectProduct
      v-if="showSelectProductAward"
      ref="selectProductAward"
      :echoDate="echoDate"
      :actId="valueRow"
      :num="1"
      :JingdouCount="JingdouCount"
      :actType="activityData.id"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheDataAward"
    >
    </selectProduct>
    <!-- 选择优惠券 -->
    <selectPrize v-model="dialogPrize" :echoDate="echoDate"  @closePrize="closePrize"></selectPrize>
    <!-- 选择人群 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList" @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import activityPageSettings from "./components/activityPageSettings.vue"
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import selectPeople from "@/components/select-people-yunqi.vue";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import {
  getComment,
  editCommentCreate,
  commentCreate,
  splitCouponCreate,
  getSplitCoupon,
  editSplitCoupon,
  redPacketCreate,
  getredPacket,
  sellerImage,
  hdTaskTemplateGroup,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import addPrizeNum from "./components/add-prize-num.vue";
import evaluatePreviewDialog from "./components/newActPreviews/evaluate-preview-dialog.vue"
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    activityPageSettings,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    newPrizeTable,
    evaluatePreviewDialog,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    statusComment: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    isShowActInfo() {
      return this.activityData.id == 20&&this.ruleDto.activityType == 1
    },
    themeTitle() {
      return this.isShowActInfo ? '主题' : ''
    },
    backgroundImage() {
      return this.ruleDto.cusTemplateJSON
        ? JSON.parse(this.ruleDto.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    evaluateSize() {
      return this.ruleDto.activityType == 1 ?  1740 : 1419;
    },
    designSpecificationsUrl() {
      if(this.activityData.id == 20) {
        if(this.ruleDto.activityType != 1) {
          return this.designSpecificationsList[this.activityData.id]
        } else {
          return "https://cdn-image.yucrm.cn/images/tb-front-platform/images/prompt/evaluatePolitely2.png"
        }
      } else {
        return this.designSpecificationsList[this.activityData.id]
      }
    },
    newGiftList() {
      if(this.activityData.id != 20) {
        return this.giftList
      } else {
       return this.commonGiftList
      }
    }
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });

      this.winningRate = this.winningRate.toFixed(5);
    },
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          if(this.activityData.id == 20) {
            this.getCodeIMGNew();
          } else {
            this.getCodeIMG();
          }
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
  },
  filters: {
    prizeType(num,type) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "12") {
        result = type ? '令牌' : '专享价';
      } else if (num == "14") {
        result = "实物（随单发）";
      } 
      return result;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },
  data() {
    return {
      templateObj: {
        url: "",
      },
      commonGiftList: [],
      customerPaperwork: {
        title: "好评有礼",
        desc: "参与好评即可得好礼",
        titleColor: "",
        btnUrl: ""
      },
      currrentRgb: "",
      isIndex: false,
      tableInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          slotHead: "totalAmountHeader",
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slot: "dailyLimit",
          slotName: "dailyLimitName",
          minWidth: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 142,
        },
      ],
      evaluatePrizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 1,
        },
      ],
      turntableType:0,
      actEndTime: "",
      isShowTip: false,
      showSelectProductAward: false,
      showSelectProduct: false,
      // 1.14迭代 指定入会时间
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
        cusTemplateJSON: "", // 自定义背景图
        isForceRemind: false, // 是否强制提醒
        activityType: 0,
        receiveType: 0,
        receiveNum: "",
      },
      isKeyActivity: 0,
      placementPosition: [],
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()-24*60*60*1000
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      appraiseValue: "1",
      options: [
        {
          value: "1",
          label: "近7天完成的评价",
        },
        {
          value: "2",
          label: "近15天完成的评价",
        },
        {
          value: "3",
          label: "近1个月完成的评价",
        },
        {
          value: "4",
          label: "近2个月完成的评价",
        },
        {
          value: "0",
          label: "自定义",
        },
      ],
      scores: ["5"],
      labelVal: [
        {
          name: "一星",
          value: "1",
        },
        {
          name: "二星",
          value: "2",
        },
        {
          name: "三星",
          value: "3",
        },
        {
          name: "四星",
          value: "4",
        },
        {
          name: "五星",
          value: "5",
        },
      ],
      winningRate: 0,
      theNum: 0,
      index: 0,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      // 裂变
      dialogPrize: false,
      indexCoupon: 0,
      FissionVoucherList: [
        // 奖项设置
        {
          title: "",
          prizeType: null,
          price: null,
          totalAmount: null,
          quota: "",
          assetsId: "",
          groupNums: "",
          couponType: "",
        },
      ],
      // 红包雨
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      awardIndex: 0,
      draggingIdFilter: [],
      mainImagelistFilter: [],
      isDraggingFilter: false,
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      levelList: [],
      disableTime: false,
      qrcode: null,
      order: "",
      showDialog: false,
      isShow: false,
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            // return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime() || time.getTime() < Date.now() - 8.64e7;
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        // selectableRange: (() => {
        //   let data = new Date();
        //   let hour = data.getHours();
        //   let minute = data.getMinutes();
        //   let second = data.getSeconds();
        //   return [`${hour}:${minute}:${second} - 23:59:59`];
        // })(),
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startCommentTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.startCommentTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            // return time.getTime() > new Date(this.ruleForm.orderEndTime).getTime();
            const day = 24 * 60 * 60 * 1000 * 60;
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime() - day
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        // {
        //   continueSignPoints: "",
        //   days: "",
        // },
      ],
      // itemArrOne: [],
      localStep: 0,
      localStepNum: this.activityData.id,
      ruleForm: {
        // 评价有礼
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        activityRulesText: "", //生成规则
        // 评价有礼
        condFollow: false, // 是否需要关注店铺
        totalMaxRewardNumber: "", //活动期间最大中奖次数
        oneDayMaxRewardNumber: "", //每人每天最大中奖次数
        startCommentTime: "", //评价开始时间
        endCommentTime: "", //评价结束时间
        commentFilter: "", // 评价内容限制，多个用英文逗号隔开
        wordNum: "", //评价字数限制
        imgNum: "", //评价图片张数限制
        videoNum: "", //评价视频限制
        isCommentFilter: false, //是否勾选过滤条件
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        //红包雨
        gameTime: "30",
        everyoneWinningNum: "",
        winningNum: "",
        itemList: [], //曝光商品集合
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片

        // 裂变神券-进店设置
        goShopSetting:0, //进店设置
        goShopAppId: '',//小程序appId
        goShopUrl: '',//小程序页面路径
        isValidBlackList: 0,
      },
      sharePic: "",
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
      },
      orderCRM: false,
      orderCRMtime: "",
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}`,
      orderShow: false,
      isStart: false,
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  created() {
    this.isStart = this.activityData.isStart ? true : false;
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
    console.log(this.activityData.id,'活动类型===========》');
    // 数据初始化
    if(this.activityData.id != 20) {
      this.getPolite();
    }
    // 修改 数据回显
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      if (this.activityData.id == 20) this.getCommentEdit();
      if (this.activityData.id == 21) this.getSplitCouponEdit();
      if (this.activityData.id == 22) this.getRedParker();
    }
    // 新增活动默认时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30)[0]
      this.ruleForm.activityEndTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  mounted() {
    this.getLevel();
    if(this.activityData.id == 20) {
      this.hdTaskTemplateGroup();
    }
    this.$nextTick(() => {
      this.getCodeIMG();
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 602,
          height: 94,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.btnUrl = res.data;
          this.$message.success("按钮背景图上传成功");
        }
      }
    },
    getTemplate() {
      if(this.ruleDto.activityType==0) {
        this.commonGiftList = this.giftList.filter((item)=>item.layout !=3)
      } else {
        this.commonGiftList = this.giftList.filter((item)=>item.layout == 3)
      }
    },
    changeActivityType(val) {
      this.getTemplate()
      if(this.commonGiftList.length) {
        this.templateId = this.commonGiftList[0].id;
        const templateItem = this.commonGiftList[0];
        this.templateObj = templateItem;
        if(this.templateId) {
          this.initCustomizeData(templateItem)
        }
      }
    },
    initCustomizeData(row) {
      this.customerPaperwork.titleColor = row.rgb;//主题文字颜色
      this.currrentRgb = row.rgb; //重置时使用主题文字颜色
    },
    addEvaluatePrize() {
      if(this.evaluatePrizeList.length >= 4) {
        this.$message.error("最多添加4个奖品！")
        return
      }
      this.evaluatePrizeList.push(      {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 1,
        },)
    },
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      console.log(arrStr,index,this[arrStr][index])
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    
    // 打开选择人群
    openCrowd(){
      this.peopleList = this.peopleSelected.map(item => {
        return { id: item }
      })
      this.selectPeopleShow = true
      this.actMember = "3"
    },
    // 选择人群关闭
    selectPeopleSure(val){
      this.peopleSelected = val.map(item=>item.id)
      this.selectPeopleShow = false
    },
    // 京东计划数量计算
    prizeNum(row){
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if([5,6,7,8,10].includes(Number(row.prizeType))){
        if(Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)){
          row.totalAmount = ""
          if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      if(this.isStart){
        if(row.totalAmount < row.minNum && row.minNum){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.message);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      if(this.activityData.isStart) return
      this.ruleForm.sharePic = this.sharePic
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate =  Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if(nowDate > startDate){
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      }else{
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleTem(item,index){
      this.tabActive = index;
      this.navItem = item;
      if(this.activityData.id == 20) {
        this.sellerImage()
      }
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.sellerImage()
    },

    // 活动模板
    async sellerImage() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.getTemplate()
      if(this.commonGiftList.length) {
        const templateItem = this.commonGiftList.find(v=> v.id == this.templateId);
        this.templateObj = templateItem;
        if(!this.activeValue) {
          this.nextStepKai(this.commonGiftList[0],2)
        } 
        // else if(templateItem) {
        //   this.nextStepKai(templateItem,2)
        // }
        if(this.templateId&&this.ruleDto.activityType==1) {
          this.currrentRgb = templateItem.rgb; //重置时使用主题文字颜色
        } 
      }

      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMGNew();
      });
    },

    // 数据初始化
    async getPolite() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          templateUrl: "",
          updateTime: "2021-11-12 10:19:55",
          title: "",
        },
      ];
      if (this.activityData.id == 20) {
        this.giftList[0].templateUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/pjyl.jpg";
        this.giftList[0].title = "评价有礼";
        this.giftList[0].id = this.activityData.id
      } else if (this.activityData.id == 21) {
        this.giftList[0].templateUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/lbsq.png";
        this.giftList[0].imageUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/lbsq.png";
        this.giftList[0].title = "裂变神券";
        this.giftList[0].id = this.activityData.id;
        console.log(this.activeValue,'activeValueactiveValueactiveValue');
        
        this.nextStepKai(this.giftList[0],2)
      } else {
        this.giftList[0].title = "红包雨";
        this.giftList[0].templateUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/tjhby.png";
        this.giftList[0].imageUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/tjhby.png";
        this.giftList[0].id = this.activityData.id
        this.nextStepKai(this.giftList[0],2)
      }
    },
    // 修改 评价有礼 数据回显
    getCommentEdit() {
      getComment(this.valueRow.id).then((res) => {
        // this.activityTimeValue = [
        //   String(res.data.startTime),
        //   String(res.data.endTime),
        // ];
        this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        if(res.data.templateJson){
          let templateJson = JSON.parse(res.data.templateJson)
          this.turntableType = templateJson.templateType?templateJson.templateType:0
        }
        // 1.14需求 这里回显
        this.ruleDto = {
          isCheckOpenCardTime:res.data.ruleDTO.isCheckOpenCardTime,
          openCardStartTime:res.data.ruleDTO.openCardStartTime,
          openCardEndTime:res.data.ruleDTO.openCardEndTime,
          plusObject:res.data.ruleDTO.plusObject, //plus会员
          cusTemplateJSON: res.data.ruleDTO.cusTemplateJSON, // 自定义背景图
          isForceRemind: res.data.ruleDTO.isForceRemind, // 是否强制提醒
          activityType: res.data.ruleDTO.activityType || 0, // 活动类型
          receiveType: res.data.ruleDTO.receiveType, // 接收类型
          receiveNum: res.data.ruleDTO.receiveNum, // 接收数量
        }
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];

        if(res.data.ruleDTO.customerPaperwork){
          this.customerPaperwork = JSON.parse(res.data.ruleDTO.customerPaperwork)
        }
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDTO.firstOpenCardTimeType;
        this.ruleForm.openCardBeforeDay = res.data.ruleDTO.openCardBeforeDay;
        this.ruleForm.openCardFollow = res.data.ruleDTO.openCardFollow;
        
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
        // 模板id
        this.templateId = res.data.templateId;
        // 奖品
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        this.ruleForm.isCommentFilter = res.data.ruleDTO.isCommentFilter
          ? true
          : false;
        this.ruleForm.videoNum = res.data.ruleDTO.videoNum;
        this.ruleForm.wordNum = res.data.ruleDTO.wordNum;
        this.ruleForm.imgNum = res.data.ruleDTO.imgNum;
        this.ruleForm.startCommentTime = res.data.ruleDTO.startCommentTime;
        
        this.ruleForm.endCommentTime = res.data.ruleDTO.endCommentTime;
        this.ruleForm.commentFilter = res.data.ruleDTO.commentFilter;
        
        this.appraiseValue = String(res.data.ruleDTO.timeType);
        this.scores = res.data.ruleDTO.scores.split(",");

        this.ruleForm.filterType = String(res.data.ruleDTO.filterType);
        this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
        // 奖品
        if(!this.activityData.isCopy){
          if(this.ruleDto.activityType!=1) {
            this.prizeSettingList = res.data.integralParadisePrizeDTOS.map((item) => {
              // 提交地址限制回显：逗号分隔字符串转数字数组
              if (item.prizeType == 3) {
                if (item.commitAddressLimit) {
                  item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                    ? item.commitAddressLimit.split(',').map(Number)
                    : item.commitAddressLimit;
                } else {
                  item.commitAddressLimit = [0];
                }
              }
              return item;
            });
          } else {
            this.evaluatePrizeList = (res.data.integralParadisePrizeDTOS&&res.data.integralParadisePrizeDTOS.length ? res.data.integralParadisePrizeDTOS : [        {
              assetsId: null, // 资产项id(计划id优惠卷id商品id)
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
              singleAmount: "",
              prizeObjectType: 1,
            }]).map((item) => {
              // 提交地址限制回显：逗号分隔字符串转数字数组
              if (item.prizeType == 3) {
                if (item.commitAddressLimit) {
                  item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                    ? item.commitAddressLimit.split(',').map(Number)
                    : item.commitAddressLimit;
                } else {
                  item.commitAddressLimit = [0];
                }
              }
              return item;
            });
          }
          this.ruleForm.oneDayMaxRewardNumber =
          res.data.ruleDTO.oneDayMaxRewardNumber;
          this.ruleForm.totalMaxRewardNumber =
          res.data.ruleDTO.totalMaxRewardNumber;
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          // 指定购买商品
          if (res.data.ruleDTO.filterType == 1) {
            this.itemListForFilter = res.data.ruleDTO.itemList && res.data.ruleDTO.itemList.length?res.data.ruleDTO.itemList:[];
            this.selectGoodsFilterArr = this.itemListForFilter;
            this.mainImagelistFilter = this.itemListForFilter;
          }
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
        }

        this.prizeSettingList.forEach((item, index) => {
          item.index = index;
          item.minNum = item.totalAmount
          if (item.percentage) {
            this.winningRate += Number(item.percentage);
          }
        });
        this.winningRate = this.winningRate.toFixed(5);

        this.ruleForm.shareTitle = res.data.ruleDTO.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDTO.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDTO.sharePic;
        this.activityTimeChange();
        if(this.ruleDto.activityType&&this.ruleDto.activityType==1) {
          this.sellerImage()
        }
      });
    },
    // 修改 裂变 数据回显
    getSplitCouponEdit() {
      getSplitCoupon(this.valueRow.id).then((res) => {
        // this.activityTimeValue = [
        //   String(res.data.startTime),
        //   String(res.data.endTime),
        // ];
        this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        // 1.14需求 这里回显
        this.ruleDto = {
          isCheckOpenCardTime:res.data.ruleDto.isCheckOpenCardTime,
          openCardStartTime:res.data.ruleDto.openCardStartTime,
          openCardEndTime:res.data.ruleDto.openCardEndTime,
          plusObject:res.data.ruleDto.plusObject, //plus会员
          cusTemplateJSON: res.data.ruleDto.cusTemplateJSON, // 自定义背景图
          isForceRemind: res.data.ruleDto.isForceRemind, // 是否强制提醒
        }
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
        this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay;
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow;
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {};
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
        if(res.data.ruleDto.customerPaperwork){
          this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
        }
        // 奖品
        if(!this.activityData.isCopy){
          this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
          this.FissionVoucherList = res.data.pointActivityPrizeDTOList;
          this.FissionVoucherList.forEach(item=>item.minNum=item.totalAmount)
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
        }
        // 奖品
        if(res.data.ruleDto){
          this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
          this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
          this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        }else{
          this.ruleForm.shareTitle = "";
          this.ruleForm.shareIntroduce = "";
          this.ruleForm.sharePic = "";
        }

        //tapd 进店逛逛
        this.ruleForm.goShopSetting = res.data.ruleDto.goShopSetting;
        this.ruleForm.goShopAppId = res.data.ruleDto.goShopAppId;
        this.ruleForm.goShopUrl = res.data.ruleDto.goShopUrl;

        this.activityTimeChange();
      });
    },
    // 修改 红包雨 数据回显
    getRedParker() {
      getredPacket(this.valueRow.id).then((res) => {
        console.log(res,'红包雨回显数据');
        // this.activityTimeValue = [
        //   String(res.data.startTime),
        //   String(res.data.endTime),
        // ];
        this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel
          ? res.data.allowLevel.split(",")
          : ["-1"];
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        // 1.14需求 这里回显
        this.ruleDto = {
          isCheckOpenCardTime:res.data.rule.isCheckOpenCardTime,
          openCardStartTime:res.data.rule.openCardStartTime,
          openCardEndTime:res.data.rule.openCardEndTime,
          plusObject:res.data.rule.plusObject, //plus会员
          cusTemplateJSON: res.data.rule.cusTemplateJSON, // 自定义背景图
          isForceRemind: res.data.rule.isForceRemind, // 是否强制提醒
        }
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        this.ruleForm.firstOpenCardTimeType = res.data.rule.firstOpenCardTimeType;
        this.ruleForm.openCardBeforeDay = res.data.rule.openCardBeforeDay;
        this.ruleForm.openCardFollow = res.data.rule.openCardFollow;
        if(res.data.rule.customerPaperwork){
          this.customerPaperwork = JSON.parse(res.data.rule.customerPaperwork)
        }
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
        // 奖品
        this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
        if(!this.activityData.isCopy){
          this.awardSettingsLsit = res.data.awardSettings;
          // 复制当前项的奖品总数为最小值
          this.awardSettingsLsit.forEach(item=>item.minNum=item.totalAmount)
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.everyoneWinningNum = res.data.rule.everyoneWinningNum;
          this.ruleForm.winningNum = res.data.rule.winningNum;
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
        }
        
        this.ruleForm.gameTime = res.data.rule.gameTime;

        this.ruleForm.shareTitle = res.data.rule.shareTitle;
        this.ruleForm.shareIntroduce = res.data.rule.shareIntroduce;
        this.ruleForm.sharePic = res.data.rule.sharePic;

        this.activityTimeChange();
      });
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleMaxWin = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(5);
      }
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].singleAmount = 1;
        this.prizeSettingList[this.index].quota = data.quota;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          delete this.prizeSettingList[this.index].isGoodManage
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
        this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime;
        this.prizeSettingList[this.index].predictSendTime = data.predictSendTime;
        this.prizeSettingList[this.index].shouldCollectExtraData = data.shouldCollectExtraData; //是否需要额外信息
        this.prizeSettingList[this.index].extraQuestion = data.extraQuestion; //额外问题
        this.prizeSettingList[this.index].addressFillLimit = data.addressFillLimit;
        this.prizeSettingList[this.index].commitAddressLimit = data.commitAddressLimit;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price =
        data.discount || data.singleAmount;

      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        if(data.name) this.prizeSettingList[this.index].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if([2,5,6,7,8,10].includes(Number(prizeType))){
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false
    },
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList
      this.echoDate = row;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      this.showSelectProduct = true
      this.$nextTick(()=>{
        this.$refs.selectProduct.openDialog();
      })
      console.log("this.JingdouCount.prizeCount", this.JingdouCount.prizeCount);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },

    getCodeIMGNew() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].secondImageUrl,
        });
      }
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      const url = `${this.telCode}&activityType=${this.activityData.id}`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
        });
      }
    },
    // 裂变  奖品确定
    closePrize(val, params) {
      console.log(params);
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        let isflay = false;
        this.FissionVoucherList.forEach((item) => {
          if (item.assetsId === params.couponId) {
            isflay = true;
          }
        });
        // if (isflay) {
        //   return this.$message.warning("你已选用该优惠券，请重新选择");
        // }
        this.FissionVoucherList[this.indexCoupon].quota = params.quota;
        this.FissionVoucherList[this.indexCoupon].prizeType = 1;
        this.FissionVoucherList[this.indexCoupon].assetsId = params.couponId;
        this.FissionVoucherList[this.indexCoupon].couponType =
          params.couponType;
        this.FissionVoucherList[this.indexCoupon].price =
          params.discount || params.singleAmount;
        this.FissionVoucherList[this.indexCoupon].title =
          params.name.length >= 12 ? params.name.substring(0, 12) : params.name;
          this.FissionVoucherList[this.indexCoupon].prizeGoShop = params.prizeGoShop
      }
      this.dialogPrize = false;
    },
    // 裂变  选择奖品
    selectCoupon(row,index) {
      if(this.isStart) return;
      this.dialogPrize = true;
      this.echoDate = row;
      this.indexCoupon = index;
    },
    // 裂变  添加优惠券
    addCoupon() {
      this.FissionVoucherList.push({
        title: "",
        prizeType: null,
        price: null,
        totalAmount: null,
        quota: "",
        assetsId: "",
        groupNums: "",
        couponType: "",
      });
    },
    // 裂变  清空  删除
    deleteaCoupon(item, num = "2") {
      // 1为清空
      if (num === "1") {
        item.title = "";
        item.prizeType = null;
        item.price = "";
        item.totalAmount = "";
        item.assetsId = "";
        item.quota = "";
        item.groupNums = "";
        item.couponType = "";
      } else {
        this.FissionVoucherList.splice(item, 1);
      }
    },
    // 红包雨  弹框
    getTheDataAward(data, prizeType) {
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }

      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
          delete this.awardSettingsLsit[this.awardIndex].isGoodManage
        } else {
          this.awardSettingsLsit[this.awardIndex].isGoodManage = data.isGoodManage;
        }
        this.awardSettingsLsit[this.awardIndex].isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.awardSettingsLsit[this.awardIndex].addressFillEndTime = data.addressFillEndTime;
        this.awardSettingsLsit[this.awardIndex].predictSendTime = data.predictSendTime;
        this.awardSettingsLsit[this.awardIndex].shouldCollectExtraData = data.shouldCollectExtraData; //是否需要额外信息
        this.awardSettingsLsit[this.awardIndex].extraQuestion = data.extraQuestion; //额外问题
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }
      this.awardSettingsLsit[this.awardIndex].price =
        data.discount || data.singleAmount;

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId || data.skuId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        this.awardSettingsLsit[this.awardIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.awardSettingsLsit[this.awardIndex],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if([2,5,6,7,8,10].includes(Number(prizeType))){
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
      this.showSelectProductAward = false
    },
    // 红包雨
    selectPacket(index, item) {
      if(this.isStart) return;
      this.itemArr = this.awardSettingsLsit
      this.echoDate = item;
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.showSelectProductAward = true
      this.$nextTick(()=>{
        this.$refs.selectProductAward.openDialog();
      })
    },
    // 添加优惠券
    addPacket() {
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        awardMinScore: null,
        awardMaxScore: null,
        awardLevel: null,
      });
    },
    // 清空  删除
    deletePacket(item, num = "2") {
      // 1为清空
      if (num === "1") {
        item.prizeType = null;
        item.price = null;
        item.title = "";
        item.totalAmount = "";
        item.awardMinScore = null;
        item.awardMaxScore = null;
        item.awardLevel = "";
      } else {
        this.awardSettingsLsit.splice(item, 1);
      }
    },
    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 0;
      if(items.id) {
        this.templateId = items.id
      }
      this.$emit("titopName", this.activityData.name, true);
      if(this.activityData.id == 20){
        this.templateObj = items;
        if(this.ruleDto.activityType==1) {
          this.initCustomizeData(items)
        }
        this.turntableType = items.templateType?items.templateType:0
        if(this.turntableType == 1){
          this.prizeSettingList.splice(4,4)
        }else{
          if(this.prizeSettingList.length<8){
            for(let i = 0;i<=8;i++){
              this.addPrizeItem()
            }
          }
        }
      }
    },
    addPrizeItem() {
      let pushData = {
        index: 1,
        prizeType: 9,
        price: null,
        title: "谢谢参与",
        totalAmount: null,
        percentage: null,
      }
      pushData.index = this.prizeSettingList.length
      if (this.prizeSettingList.length < 8) {
        this.prizeSettingList.push(pushData)
      }
    },
    delPrizeItem(indexValue) {
      this.prizeSettingList.splice(indexValue,1)
      this.prizeSettingList.forEach((item,index)=>{
        item.index = index
      })
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    clearOrderTime() {
      if (!this.isSave) return;
      if (!this.isStart) return;
      this.ruleForm.startCommentTime = null;
      this.ruleForm.endCommentTime = null;
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    // 参与商品删除
    delecFilter(index) {
      this.mainImagelistFilter.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    // 参与商品图片拖拽
    onEndFilter() {
      this.isDraggingFilter = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelistFilter.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingIdFilter = arr;
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let commentStart = new Date(this.ruleForm.startCommentTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart =
      //   this.ruleForm.activityStartTime &&
      //   this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd =
      //   this.ruleForm.activityEndTime &&
      //   this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      const day = 86400000 * 60;
      if (start - commentStart > day && commentStart && start) {
        this.ruleForm.startCommentTime = "";
        this.$message.warning("评价开始时间最小范围在活动时间的前60天");
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 评价规则判断
    orderChange() {
      let start = new Date(this.ruleForm.startCommentTime).valueOf();
      let end = new Date(this.ruleForm.endCommentTime).valueOf();
      let activityStartTime = new Date(
        this.ruleForm.activityStartTime
      ).valueOf();
      if (start > end && start && end) {
        this.$message.warning("评价开始时间不能大于评价结束时间");
        this.ruleForm.startCommentTime = null;
        return;
      }
      const day = 86400000 * 60;
      if (activityStartTime - start > day && activityStartTime && start) {
        this.ruleForm.startCommentTime = "";
        this.$message.warning("评价开始时间最小范围在活动时间的前60天");
      }
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) >
          Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.totalMaxRewardNumber &&
        this.ruleForm.oneDayMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
      if (
        Number(this.ruleForm.everyoneWinningNum) >
          Number(this.ruleForm.winningNum) &&
        this.ruleForm.everyoneWinningNum &&
        this.ruleForm.winningNum
      ) {
        this.ruleForm.winningNum = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    // 返回上一步
    returnBack() {
      // this.$emit("returnBack");
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      if(this.ruleDto.activityType == 1&&this.ruleDto.receiveType==1&&this.ruleDto.receiveNum) {
        if(+this.ruleDto.receiveNum>this.evaluatePrizeList.length) {
          this.$message.warning("可领取数量不得大于奖品数量");
          return;
        }
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      // 评价
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        isValidBlackList: this.ruleForm.isValidBlackList,
        // 1.14需求 这里提交

        ruleDTO: {
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          openCardBeforeDay: this.ruleForm.openCardBeforeDay,
          openCardFollow: this.ruleForm.openCardFollow,
          isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          plusObject:this.ruleDto.plusObject, //plus会员
          cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
          isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber, //近X天内未购
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          startCommentTime:
            this.appraiseValue == "0" ? this.ruleForm.startCommentTime : "",
          endCommentTime:
            this.appraiseValue == "0" ? this.ruleForm.endCommentTime : "",
          timeType: this.appraiseValue, //评价时间类型  0自定义 1近七天 2近15天 3近1个月 4 近2个月
          scores: this.scores.join(","),
          wordNum: this.ruleForm.wordNum,
          imgNum: this.ruleForm.imgNum,
          videoNum: this.ruleForm.videoNum,
          isCommentFilter: this.ruleForm.isCommentFilter ? 1 : 0,
          commentFilter: this.ruleForm.commentFilter,
          filterType: this.ruleForm.filterType,
          skuIdList:
            this.ruleForm.filterType == "0"
              ? ""
              : this.itemListForFilter.map((item) => item.skuId),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
             // 其他活动页配置
          customerPaperwork: JSON.stringify(this.customerPaperwork),
          activityType: this.ruleDto.activityType,
          receiveType: this.ruleDto.receiveType,
          receiveNum: this.ruleDto.receiveNum,
        }, //活动名称
        itemList: this.itemListFor, //曝光商品集合
        integralParadisePrizeDTOS: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        studentStatus: this.ruleForm.studentStatus,
      };
      if(this.ruleDto.activityType != 1){
        cardParams.integralParadisePrizeDTOS = this.prizeSettingList.map(
          (item) => {
            console.log(item);
            let prize = {
              ...item,
              percentage: item.percentage ? item.percentage : 0,
              singleMaxWin: item.singleMaxWin
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
            }
            if(prize.prizeType == 3 && prize.skuId){
              prize.assetsId = prize.skuId
            }
            // 提交地址限制：数组转逗号分隔字符串
            if (prize.prizeType == 3 && Array.isArray(prize.commitAddressLimit)) {
              prize.commitAddressLimit = prize.commitAddressLimit.join(',');
            }
            return prize;
          }
        );
      } else {
        cardParams.integralParadisePrizeDTOS = this.evaluatePrizeList.filter((item) => item.prizeType).map((item) => {
          // 提交地址限制：数组转逗号分隔字符串
          if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
            item.commitAddressLimit = item.commitAddressLimit.join(',');
          }
          return item;
        })
      }

      // 裂变
      let SplitCouponActivityDTO = {
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        itemList: this.itemListFor, //曝光商品集合
        pointActivityPrizeDTOList: this.FissionVoucherList,
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        // 1.14需求 这里提交
        ruleDTO:{
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          openCardBeforeDay: this.ruleForm.openCardBeforeDay,
          openCardFollow: this.ruleForm.openCardFollow,
          isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          plusObject:this.ruleDto.plusObject, //plus会员
          cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
          isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,

          goShopSetting: this.ruleForm.goShopSetting,
          goShopAppId: this.ruleForm.goShopAppId,
          goShopUrl: this.ruleForm.goShopUrl,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        },
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        studentStatus: this.ruleForm.studentStatus,
      };
      // 红包雨
      let redParams = {
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        itemList: this.itemListFor, //曝光商品集合
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        isValidBlackList: this.ruleForm.isValidBlackList,
        // 1.14需求 这里提交
        
        rule: {
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          openCardBeforeDay: this.ruleForm.openCardBeforeDay,
          openCardFollow: this.ruleForm.openCardFollow,
          isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          plusObject:this.ruleDto.plusObject, //plus会员
          cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
          isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

          gameTime: this.ruleForm.gameTime,
          everyoneWinningNum: this.ruleForm.everyoneWinningNum,
          winningNum: this.ruleForm.winningNum,
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        },
        awardSettings: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        studentStatus: this.ruleForm.studentStatus,
      };
      redParams.awardSettings = this.awardSettingsLsit.map((item, index) => {
        let prize = {
          ...item,
          awardLevel: index + 1,
          id: item.prizeId
        };
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
          prize.singleAmount = 1;
        } else if (prize.prizeType == 2 || prize.prizeType == 4) {
          prize.singleAmount = item.price;
        } else {
          prize.singleAmount = 1;
        }
        if(prize.prizeType == 3 && prize.skuId){
          prize.assetsId = prize.skuId
        }
        return prize;
      });
      if(this.actMember == 1){
        cardParams.allowLevel = "-1"
        redParams.allowLevel = "-1"
        SplitCouponActivityDTO.allowLevel = "-1"
      }else if(this.actMember == 3){
        cardParams.allowLevel = "99"
        cardParams.crowdIds = this.peopleSelected.join(",")
        redParams.allowLevel = "99"
        redParams.crowdIds = this.peopleSelected.join(",")
        SplitCouponActivityDTO.allowLevel = "99"
        SplitCouponActivityDTO.crowdIds = this.peopleSelected.join(",")
      }else if(this.actMember == 2){
        cardParams.allowLevel = this.ruleForm.partner.join(",")
        redParams.allowLevel = this.ruleForm.partner.join(",")
        SplitCouponActivityDTO.allowLevel = this.ruleForm.partner.join(",")
        if (cardParams.allowLevel == '-1'||redParams.allowLevel == '-1'||SplitCouponActivityDTO.allowLevel == '-1') {
          //会员等级设置
          let list = ['-1','0']
          this.levelList.forEach((item,index) => {
            let num = index + 1
            list.push(num)
          })
          cardParams.allowLevel = list.join(",")
          redParams.allowLevel = list.join(",")
          SplitCouponActivityDTO.allowLevel = list.join(",")
        }
      }
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
        SplitCouponActivityDTO.itemList = b;
        redParams.itemList = b;
      }

      //指定商品对象排序(根据对象的某一属性)
      if (this.draggingIdFilter.length != []) {
        let a = this.draggingIdFilter;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListForFilter.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.ruleDTO.skuIdList = b.map((item) => item.skuId);
      }
      
      if(!this.isDraft){
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }
        if (
          this.activityData.id == 20 ||
          this.activityData.id == 21 ||
          this.activityData.id == 22
        ) {
          if (this.ruleForm.partner.length == 0) {
            this.$message.warning("活动对象不能为空");
            return;
          }

          if (this.actMember == "2") {
            if (
              this.ruleForm.firstOpenCardTimeType == 1 &&
              (!this.ruleForm.openCardBeforeDay)
            ) {
              return this.$message.warning("请完善首次入会时间");
            }
            if (
              this.ruleForm.firstOpenCardTimeType == 2 &&
              (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
            ) {
              return this.$message.warning("请完善首次入会时间");
            }
          }
          if(this.actMember == 3 && !this.peopleSelected.length){
            this.$message.warning("请选择指定人群");
            return;
          }
          //请填写评价时间！
          if (
            (!this.ruleForm.startCommentTime || !this.ruleForm.endCommentTime) &&
            this.appraiseValue == "0"
          ) {
            this.$message.warning("请填写评价时间！");
            return;
          }
          //请填写评星设置
          if (this.scores.length === 0) {
            this.$message.warning("请填写评星设置");
            return;
          }
          //请填写过滤条件
          if (this.ruleForm.isCommentFilter) {
            if (!this.ruleForm.commentFilter) {
              this.$message.warning("请填写过滤条件");
              return;
            }
          }
          if (this.ruleForm.filterType == 1) {
            if (this.itemListForFilter.length == 0) {
              this.$message.warning("请添加参与商品！");
              return;
            }
          }
          if(this.activityData.id == 20){
            // 请将奖品填写完整！
            let isFlay = false;
            if(this.ruleDto.activityType == 0) {
              if (this.prizeSettingList.every((item) => item.prizeType == 9)) {
                this.$message.warning("请选择奖品！");
                return;
              }
              this.prizeSettingList.forEach((item) => {
                if (item.prizeType != 9) {
                  if (
                    !item.prizeType ||
                    !item.percentage ||
                    !item.totalAmount ||
                    !item.title
                  ) {
                    isFlay = true;
                  }
                }
              });
            } else {
              this.evaluatePrizeList.forEach((item) => {
                if (!item.totalAmount||!item.title) {
                  isFlay = true;
                }
              });
            }
            if (isFlay) {
              return this.$message.warning("请将奖品填写完整！");
            }
          }
        }
        if (this.activityData.id == 21) {
          // // 请将奖品填写完整！
          let isFlay = false;
          this.FissionVoucherList.forEach((item) => {
            if (!item.groupNums || !item.totalAmount || !item.title) {
              isFlay = true;
            }
          });
          if (isFlay) {
            return this.$message.warning("请将奖项填写完整！");
          }
        }
        if (this.activityData.id == 22) {
          // // 请将奖品填写完整！
          let isFlay = false;

          this.awardSettingsLsit.forEach((item) => {
            // if (!item.totalAmount || item.awardMinScore == null || item.awardMinScore == "." || !item.awardMaxScore) {
            if (
              !item.totalAmount ||
              item.awardMinScore == null ||
              !item.awardMaxScore ||
              item.price == null ||
              !item.title
            ) {
              isFlay = true;
            }
          });
          if (isFlay) {
            return this.$message.warning("请将奖项填写完整！");
          }
        }

        if(this.activityData.id == 21) {
        //新增进店设置校验
        if(this.ruleForm.goShopSetting==1 && !this.ruleForm.goShopAppId) {
          this.$message.warning("请输入小程序appId");
          return;
        }
        if(this.ruleForm.goShopSetting==2) {
          if(!this.ruleForm.goShopUrl) {
           this.$message.warning("请输入指定链接");
           return;
          }else if(!this.ruleForm.goShopUrl.startsWith('https://') || !this.ruleForm.goShopUrl.includes('jd.com')) {
            this.$message.warning("输入的内容非链接或为接口无法支持的链接，请重新设置");
            return;
          }
        }
      }

        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
        if(this.placementPosition.length==0) {    
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.activityData.id == 20) {
          if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
            let res;
            if(this.activityData.isStart){
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                prizes: cardParams.integralParadisePrizeDTOS.filter(item=>item.totalAmount).map(item=>{
                  return {
                    ...item,
                    prizeId: item.id,
                    totalAmount: item.totalAmount,
                    title:item.title
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                templateId: this.templateId,
                isValidBlackList: this.ruleForm.isValidBlackList,
                ruleDTO: cardParams.ruleDTO,
              }
              if(this.actEndTime!=this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime
              }
              res = await updateCommon(params)
            }else{
              cardParams.integralParadisePrizeDTOS.forEach(item=>{
                delete item.memberBuyPercentage
              })
              res = await editCommentCreate({ ...cardParams, id: this.valueRow.id , templateId: this.templateId })
            }
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              if(res.message){
                this.$message.error(res.message);
              }else{
                this.$message.error(res.data.message);
              }
            }
          } else {
            cardParams.templateId = this.templateId
            if(this.isDraft){
              cardParams.status = 5
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            if(this.activityData.isCopy){
              delete cardParams.id
            }
            commentCreate(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
        if (this.activityData.id == 21) {
          if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
            let res;
            if(this.activityData.isStart){
              let params = {
                activityId: this.valueRow.id,
                ruleDescription: SplitCouponActivityDTO.ruleDescription,
                prizes: SplitCouponActivityDTO.pointActivityPrizeDTOList.filter(item=>item.totalAmount).map(item=>{
                  return {
                    prizeId: item.id,
                    totalAmount: item.totalAmount,
                    title:item.title,
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDTO: {
                  firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
                  openCardBeforeDay: this.ruleForm.openCardBeforeDay,
                  openCardFollow: this.ruleForm.openCardFollow,
                  isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
                  openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
                  openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
                  plusObject:this.ruleDto.plusObject, //plus会员
                  cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
                  isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

                  shareTitle: this.ruleForm.shareTitle,
                  shareIntroduce: this.ruleForm.shareIntroduce,
                  sharePic: this.ruleForm.sharePic,

                  goShopSetting: this.ruleForm.goShopSetting,
                  goShopAppId: this.ruleForm.goShopAppId,
                  goShopUrl: this.ruleForm.goShopUrl,
                  customerPaperwork: JSON.stringify(this.customerPaperwork),
                },
                isKeyActivity: this.isKeyActivity,
                placementPosition: this.placementPosition.join(","),
              }
              if(this.actEndTime!=this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime
              }
              res = await updateCommon(params)
            }else{
              res = await editSplitCoupon({ ...SplitCouponActivityDTO, id: this.valueRow.id })
            }
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              if(res.message){
                this.$message.error(res.message);
              }else{
                this.$message.error(res.data.message);
              }
            }
          } else {
            const query = {
              ...SplitCouponActivityDTO
            }
            if(this.isDraft){
              query.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              query.pointActivityPrizeDTOList = query.pointActivityPrizeDTOList.filter(item=>item.prizeType)
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              query.id = this.valueRow.id
            }
            if(this.activityData.isCopy){
              delete query.id
            }
            splitCouponCreate(query).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
        if (this.activityData.id == 22) {
          if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
            let res;
            if(this.activityData.isStart){
              let params = {
                activityId: this.valueRow.id,
                ruleDescription: redParams.ruleDescription,
                prizes: redParams.awardSettings.filter(item=>item.totalAmount).map(item=>{
                  return {
                    prizeId: item.id,
                    totalAmount: item.totalAmount,
                    title:item.title
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDTO: {
                  firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
                  openCardBeforeDay: this.ruleForm.openCardBeforeDay,
                  openCardFollow: this.ruleForm.openCardFollow,
                  isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
                  openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
                  openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
                  plusObject:this.ruleDto.plusObject, //plus会员
                  cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
                  isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

                  gameTime: this.ruleForm.gameTime,
                  everyoneWinningNum: this.ruleForm.everyoneWinningNum,
                  winningNum: this.ruleForm.winningNum,
                  shareTitle: this.ruleForm.shareTitle,
                  shareIntroduce: this.ruleForm.shareIntroduce,
                  sharePic: this.ruleForm.sharePic,
                  customerPaperwork: JSON.stringify(this.customerPaperwork),
                },
                isKeyActivity: this.isKeyActivity,
                placementPosition: this.placementPosition.join(","),
              }
              if(this.actEndTime!=this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime
              }
              res = await updateCommon(params)
            }else{
              res = await redPacketCreate({ ...redParams, activityId: this.valueRow.id })
            }
            // redPacketCreate({
            //   ...redParams,
            //   activityId: this.valueRow.id,
            // }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              } else {
                if(res.message){
                  this.$message.error(res.message);
                }else{
                  this.$message.error(res.data.message);
                }
              }
            // });
          } else {
            const query = {
              ...redParams
            }
            if(this.isDraft){
              query.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              query.awardSettings = query.awardSettings.filter(item=>item.prizeType)
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              query.id = this.valueRow.id
            }
            redPacketCreate(query).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$message.success(res.message);
                  // this.$emit("saveEdit");
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }

        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 =
          this.ruleForm.filterType == "0"
            ? "2.全部商品评价参与；"
            : "2.部分商品评价参与；",
        text3 =
          "4.单个订单中包含几款商品则可获几次抽奖机会，虚拟商品无法获得抽奖机会；",
        text4 =
          "5.奖品数量有限，先到先得，如果是实物奖项，请及时填写地址便于奖品发放；",
        text5 =
          "6.平台需要对评价内容进行审核，如果没有获得参与机会，请检查订单的评价状态，耐心等待；",
        text6 = "";
      const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,false);
      let secondTextStr = "\n二、【如何参与】";
      let thirdTextStr = "";
      let fourthTextStr = `\n\n三、【注意事项】\n1.${ precautions }`;
        
      let Arr1 = [];
      // 评价有礼
      if (this.activityData.id == 20) {
        secondTextStr += "\n1.参与方式：按要求完成订单好评后，在活动期间进入活动手动抽取奖品；\n" + text2;
        // 评价规则
        let evaluateRule = []
        if(this.appraiseValue != '0') {
          this.options.forEach(item=>{
            if(item.value == this.appraiseValue){
              evaluateRule.push(`评价时间：${item.label}`)
            }
          })
        }else {
          evaluateRule.push(`评价时间：${this.ruleForm.startCommentTime}-${this.ruleForm.endCommentTime}`)
        }
        if(this.itemListForFilter.length > 0 && this.ruleForm.filterType == '1'){
          evaluateRule.push(`指定商品：${this.itemListForFilter.map(item=>item.title).join(';')}`)
        }else {
          evaluateRule.push(`指定商品：不限`)
        }
        if (this.scores && this.scores.length > 0) {
          let stars = [];
          this.labelVal.forEach(item => {
            if (this.scores.includes(item.value)) {
              stars.push(item.name);
            }
          });
          if (stars.length > 0) {
            evaluateRule.push(`评星要求：${stars.join('，')}；`);
          } else {
            evaluateRule.push(`评星要求：不限`);
          }
        } else {
          evaluateRule.push(`评星要求：不限`);
        }
        if(this.ruleForm.wordNum) {
          evaluateRule.push(`评价字数要求：评价至少${this.ruleForm.wordNum}字`)
        }else {
          evaluateRule.push(`评价字数要求：不限`)
        }
        if(this.ruleForm.imgNum) {
          evaluateRule.push(`评价图片要求：包含至少${this.ruleForm.imgNum}张图片`)
        }else {
          evaluateRule.push(`评价图片要求：不限`)
        }
        if(this.ruleForm.videoNum && this.ruleForm.videoNum != '0') {
          evaluateRule.push(`评价视频要求：包含至少${this.ruleForm.videoNum}段视频`)
        }else {
          evaluateRule.push(`评价视频要求：不限`)
        }
        if(this.ruleForm.isCommentFilter) {
          evaluateRule.push(`评价内容不能包含关键字：${this.ruleForm.commentFilter};`)
        }else {
          evaluateRule.push(`评价内容：不限`)
        }
        secondTextStr += "\n3.评价规则：";
        evaluateRule.forEach((item, index)=>{
          secondTextStr += `\n（${index+1}）${item}`
        })
        secondTextStr += "\n4.单个订单中包含几款商品则可获几次抽奖机会，虚拟商品无法获得抽奖机会；"
         + "\n5.奖品数量有限，先到先得，如果是实物奖项，请及时填写地址便于奖品发放；"
         + "\n6.平台需要对评价内容进行审核，如果没有获得参与机会，请检查订单的评价状态，耐心等待；";
      }
      // 裂变神劵
      if (this.activityData.id == 21) {
        text3 = "\n1.按照成团人数要求完成组队；";
        text4 = "\n2.活动期间，同一优惠，用户只能为一位好友助力；";
        text5 = "\n3.同一优惠，同一用户最多只能享受一次；";
        text6 = "\n4.优惠券数量有限，先到先得；";
        secondTextStr += text3 + text4 + text5 + text6;
        fourthTextStr = `\n\n三、【注意事项】\n注：优惠券发放形式：
  (1）领取型优惠券：中奖后需手动领取，预计24小时到账；
  (2）发放型优惠券：中奖后无需手动领取，系统自动发放至中奖账户；
【活动参与主体资格】
  (1）每位自然人用户仅能使用一个京东账号参与活动，微信号、QQ、京东帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效；
  (2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其参与资格
【注意事项】
  (1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其参与资格（如优惠已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利；
  (2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动；
  (3）是否获得优惠以活动发布者后台统计结果为准。`
      }
      // 红包雨
      if (this.activityData.id == 22) {
        let jointext = [
          "参与方式：在游戏时间范围内，每抓住一个红包可获得10分，抓住的红包越多，越有机会获得奖品；",
          `游戏时间：${this.ruleForm.gameTime}秒;`,
        ];
        if(this.ruleForm.everyoneWinningNum && this.ruleForm.winningNum) {
          jointext.push(`中奖限制：活动期间每人每天中奖不超过${this.ruleForm.everyoneWinningNum}次，累计中奖不超过${this.ruleForm.winningNum}次;`)
        }else if(this.ruleForm.everyoneWinningNum) {
          jointext.push(`中奖限制：活动期间每人每天中奖不超过${this.ruleForm.everyoneWinningNum}次;`)
        }else if(this.ruleForm.winningNum) {
          jointext.push(`中奖限制：活动期间累计中奖不超过${this.ruleForm.winningNum}次;`)
        }
        jointext.push('礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；')
        jointext.push('若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）;')
        jointext.forEach((item,index)=>{
          secondTextStr += `\n${index+1}.${item}`
        })
        thirdTextStr = "\n\n三、【活动奖品】";
        fourthTextStr = fourthTextStr.replace("三、","四、");
        if(this.awardSettingsLsit && this.awardSettingsLsit.length > 0){
          this.awardSettingsLsit.forEach((item,index)=>{
            if(item.prizeType == 3) {
              // 实物
              thirdTextStr += `\n（${index+1}）${this.$options.filters.toChinesNum(index + 1)}等奖：${item.awardMinScore}~${item.awardMaxScore}分；${item.title}，共${item.totalAmount}份，价值${item.price}元；`
            }else {
              thirdTextStr += `\n（${index+1}）${this.$options.filters.toChinesNum(index + 1)}等奖：${item.awardMinScore}~${item.awardMaxScore}分；${item.title}，共${item.totalAmount}份；`
            }
          })
        }
      }
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = firstTextStr + secondTextStr + thirdTextStr + fourthTextStr + newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      // console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        this.itemListForFilter = [];
        this.mainImagelistFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          this.mainImagelistFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 2 || e.target.value > 5) {
            e.target.value = "";
          }
        }
        return e.target.value
      } else {
        if (
          num.quantityTotal &&
          num.price &&
          num.totalAmount &&
          num.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...num,
            prizeCount: num.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = "";
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.awardIndex = 0;
      this.draggingIdFilter = [];
      this.mainImagelistFilter = [];
      this.isDraggingFilter = false;
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    // 组队人数是发放的N倍
    multiple(num, num1, index, row) {
      if(this.isStart){
        if(row.totalAmount < row.minNum && row.minNum){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          return
        }
        if (Number(num1) % Number(num) != 0) {
          this.$message.warning(
            "发放人数必须为组队人数的N倍，以确保奖品发放顺利；"
          );
          this.FissionVoucherList[index].totalAmount = row.minNum;
        }
      }else{
        if (!num) {
          this.$message.warning("请先填写组队人数！");
          this.FissionVoucherList[index].totalAmount = "";
        } else {
          if (Number(num1) % Number(num) != 0) {
            this.$message.warning(
              "发放人数必须为组队人数的N倍，以确保奖品发放顺利；"
            );
            this.FissionVoucherList[index].totalAmount = "";
          }
        }
      }
    },
    // 区间递减
    scoreChange(item, index) {
      if (index != 0) {
        const num = Number(this.awardSettingsLsit[index - 1].awardMinScore);
        if (Number(item.awardMaxScore) >= num) {
          this.awardSettingsLsit[index].awardMaxScore = "";
          this.$message.warning("奖项设置分数必须是递减的，且区间不能重复；");
          return;
        }
      }
      if (
        (Number(item.awardMaxScore) <= Number(item.awardMinScore) &&
          item.awardMinScore &&
          item.awardMaxScore) ||
        item.awardMaxScore == 0
      ) {
        this.awardSettingsLsit[index].awardMaxScore = "";
        this.$message.warning("奖项设置最大分数必须大于最小分数");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
.inputcount {
  /deep/.el-input__count {
    display: none !important;
  }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #fe4d45;
  }
}
.s {
  color: #fe4d45;
  cursor: pointer;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.set {
  display: inline-block;
  margin-top: 30px;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #fe4d45;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;

  &_middle {
    padding-top: 10px;
  }
  &_content {
    padding: 0 15px;
    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }
    p {
      padding-left: 21px;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #fe4d45;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 115px;
  right: 30px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}
.flex {
  display: flex;
  align-items: center;
}

.add_btn1 {
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(254, 77, 69, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 25px;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #fe4d45;
                border-bottom: 1px solid #fe4d45;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #fe4d45;
                border-left: 1px solid #fe4d45;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              // font-family: system-ui;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url('https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/yhq.png');
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover{
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset{
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips11{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.buttonGroup {
  margin-left: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #999999;
}
</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  //   .el-step__line {
  //     background-color: #fe4d45;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  // }
  // .el-step__title.is-process {
  //   color: #fe4d45;
  // }
  // .el-step__title.is-success {
  //   color: #fe4d45;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
